// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/view-design/dist/styles/iview.css
// module id = 16
// module chunks = 25